
import React from 'react'

const NoPage = () => {
  return (
    <div>The page on your url does not exist.</div>
  )
}

export default NoPage